import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

const SignIn: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const newUserEmail = params.get("newUserEmail");

    loginWithRedirect({
      authorizationParams: {
        login_hint: "",
      },
    });
  }, []);

  return <div></div>;
};

export default SignIn;
